import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { DataManagementCreateEpisodeInfoModalComponent } from '../data-management-create-episode-info-modal/data-management-create-episode-info-modal.component';

@Component({
  selector: 'app-data-management-create-episode-modal',
  templateUrl: './data-management-create-episode-modal.component.html',
  styleUrls: ['./data-management-create-episode-modal.component.scss']
})
export class DataManagementCreateEpisodeModalComponent implements OnInit {

  show: any;
  partnerGroups: any;
  isSeasonSelected: boolean;
  @Input() selectedSeason: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DataManagementCreateEpisodeModalComponent>,
    private partnerService: PartnerService
  ) {
    this.show = data.show;
    this.partnerGroups = data.partnerGroups;
   }

  ngOnInit() {
    // the opener sets selectedSeason through componentInstance after the constructor runs,
    // so a field initializer would always see undefined
    this.isSeasonSelected = !!this.selectedSeason;
    console.log(this.show);
  }

  close(): void {
    this.dialogRef.close();
  }

  createProEpisode(season) {
    // seasonId, showId, seasonNumber
    this.partnerService.updateProEpisode(null, season.id, 1, 'new title 12/5', null).subscribe((res: any) => {
      console.log(res);
      this.close();
    });
  }

  // Method to find partner name based on ID
  findPartnerGroupName(partnerId: number | null): string {
    const partnerGroup = this.partnerGroups.find(p => p.id === partnerId);
    if (partnerGroup) {
      return partnerGroup.name
    } else {
      return partnerGroup ? this.partnerGroups.name : '';
    }
  }

  selectSeason(season) {
    this.isSeasonSelected = true;
    this.selectedSeason = season;
  }

  openEpisodeInfoModal(season, episode?) {
    const dialogConfig = new MatDialogConfig();
    if (episode) {
      dialogConfig.data = {
        season: season,
        partnerGroups: this.partnerGroups,
        episode: episode
      };
    }
    else {
      dialogConfig.data = {
        season: season,
        partnerGroups: this.partnerGroups,
      };

    }
    // dialogConfig.data = {
    //   show: show
    // };
    this.dialog.open(DataManagementCreateEpisodeInfoModalComponent, dialogConfig).afterClosed().subscribe((savedEpisode: any) => {
      // the info modal closes with the saved row only when Save Episode succeeded
      if (!savedEpisode) {
        return;
      }
      if (episode) {
        Object.assign(episode, savedEpisode);
      } else {
        season.episodes.push(savedEpisode);
      }
      // saving used to close both modals and reload every show; it still closes both, without the reload
      this.close();
    });

  }

}
